import { fireCmdbErrorAnalytics } from '@jira/servicedesk__insight-common-utils-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import { performCmdbGetRequest } from '@jira/servicedesk__insight-common-utils-cmdb-client/src/performCmdbGetRequest.tsx';
import { getDataManagerAccessibleSitesUrl } from '@jira/servicedesk__insight-common-utils-cmdb-rest-urls/src/getDataManagerProvisioningStatusUrl.tsx';
import type { ActionApi } from './ActionApi.types.tsx';

export const fetchIsDataManagerAvailable =
	(): ActionApi =>
	async ({ setState, getState }, { workspaceId }) => {
		const { dataManager } = getState();
		if (
			dataManager.isDataManagerAvailableLoading ||
			dataManager.isDataManagerAvailable !== undefined
		) {
			return;
		}

		setState({
			dataManager: {
				...dataManager,
				isDataManagerAvailableLoading: true,
			},
		});

		try {
			const { isSuccessful } = await performCmdbGetRequest<{ isSuccessful: boolean }>(
				getDataManagerAccessibleSitesUrl(workspaceId),
			);

			setState({
				dataManager: {
					...getState().dataManager,
					isDataManagerAvailable: isSuccessful ?? false,
					isDataManagerAvailableLoading: false,
				},
			});
		} catch (error: unknown) {
			const normalizedError = error instanceof Error ? error : new Error(String(error));
			setState({
				dataManager: {
					...getState().dataManager,
					isDataManagerAvailable: false,
					isDataManagerAvailableLoading: false,
				},
			});
			fireCmdbErrorAnalytics({
				meta: {
					id: 'fetchIsDataManagerAvailable',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'astral',
				},
				error: normalizedError,
			});
		}
	};
